import { DataMessage } from '@ouster/webviz';

import {
  addSensorIdentifiersToSet,
  resolveSensorKey,
  sensorMatchesId,
} from './vizSensorUtils';
import { SDKSensorInfoAugmented } from '../../types';

export function resolveMetadataSensorIndexBySelection(
  sensorsMetadata: SDKSensorInfoAugmented[],
  selectedSn: string | null
): number {
  if (!selectedSn) return -1;
  return sensorsMetadata.findIndex((meta) => sensorMatchesId(meta, selectedSn));
}

export function findSensorMetadataByIdentifier(
  sensorsMetadata: SDKSensorInfoAugmented[],
  sensorId: string | null
): SDKSensorInfoAugmented | undefined {
  const selectedMetadataIndex = resolveMetadataSensorIndexBySelection(
    sensorsMetadata,
    sensorId
  );

  if (selectedMetadataIndex < 0) {
    return undefined;
  }

  return sensorsMetadata[selectedMetadataIndex];
}

export function resolveMetadataSensorKey(
  metadata: (SDKSensorInfoAugmented & { productSn?: string }) | undefined
): string {
  return resolveSensorKey(metadata, 'unknown');
}

export function buildSelectedSensorKeys(
  sensorsMetadata: SDKSensorInfoAugmented[],
  selectedSn: string | null
): Set<string> {
  const keys = new Set<string>();
  if (selectedSn) keys.add(selectedSn);

  const selectedMetadataIndex = resolveMetadataSensorIndexBySelection(
    sensorsMetadata,
    selectedSn
  );
  if (selectedMetadataIndex >= 0) {
    addSensorIdentifiersToSet(keys, sensorsMetadata[selectedMetadataIndex]);
  }

  return keys;
}

export function findMessageForSelectedSensor({
  messages,
  selectedSn,
  sensorsMetadata,
}: {
  messages: DataMessage[];
  selectedSn: string | null;
  sensorsMetadata: SDKSensorInfoAugmented[];
}): DataMessage | undefined {
  const keys = buildSelectedSensorKeys(sensorsMetadata, selectedSn);

  if (!selectedSn || keys.size === 0) {
    return undefined;
  }

  return messages.find((msg) => {
    const sn = msg?.sensorInfo?.sn;
    return typeof sn === 'string' && keys.has(sn);
  });
}
